import type { CallAdapter } from '@/entities/call'
import type { DataEnvelope } from '@/shared/lib/livekit'
import { buildChatMessage } from '../lib/build-message'
import { type ChatEntry, useChatStore } from './chat-store'

export function useChatMessages(): ChatEntry[] {
  return useChatStore((s) => s.messages)
}

// Входящее из data-канала → в стор (только чат; реакции игнорируем здесь).
export function appendChatEnvelope(envelope: DataEnvelope, fromParticipantId: string): void {
  if (envelope.kind !== 'chat') return
  useChatStore.getState().add({
    id: envelope.id,
    text: envelope.text,
    sentAt: envelope.sentAt,
    authorId: fromParticipantId,
  })
}

// Отправка: оптимистично в стор (author='local') + публикация в data-канал.
// В mock fake-adapter эхоит обратно — дедуп по id гасит дубль.
export async function sendChatMessage(adapter: CallAdapter, text: string): Promise<void> {
  const trimmed = text.trim()
  if (!trimmed) return
  const message = buildChatMessage(trimmed)
  useChatStore.getState().add({
    id: message.id,
    text: message.text,
    sentAt: message.sentAt,
    authorId: 'local',
  })
  await adapter.publishData(message)
}
